module.exports = __webpack_public_path__ + "static/media/Group_1000006716@2x.e4af52ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Group_1000006716@2x.png
// module id = 1751
// module chunks = 0